module.exports = __webpack_public_path__ + "img/icom.be7d768a.png";